import Global from "./global";
import Dropdown from 'bootstrap5/js/dist/dropdown';
import Collapse from 'bootstrap5/js/dist/collapse'
import Tab from 'bootstrap5/js/dist/tab';
import Modal from 'bootstrap5/js/dist/modal';
import Popper from '@popperjs/core';
import Tooltip from 'bootstrap5/js/dist/tooltip';
import GalleryModal from "../gallery_modal/js/gallery_modal";

window.bootstrap5 = {
    Modal: Modal,
    Tooltip: Tooltip,
    Collapse: Collapse,
    Tab: Tab,
    Dropdown: Dropdown
}

window.Global = new Global();

document.addEventListener('shopify:section:load', function (event) {
    window.bootstrap5 = {
        Modal: Modal,
        Tooltip: Tooltip,
        Collapse: Collapse,
        Tab: Tab,
        Dropdown: Dropdown
    }

    window.Global = new Global();
});